const usePropertyDialog = ({ selectedRow }: { selectedRow: any }) => {
  const columns = [
    {
      accessorKey: "displayId",
      header: <div>Property ID</div>,
      accessorFn: (row: any) => String(row?.displayId || ""),
    },
    {
      accessorKey: "propertyName",
      header: <div>Property Name</div>,
      accessorFn: (row: any) => String(row?.propertyName || ""),
    },
    {
      accessorKey: "communities",
      header: <div>Community Name</div>,
      accessorFn: (row: any) => selectedRow?.communities?.find((data: any) => data?.communityId == row?.communityId)?.communityName || "",
    },
  ]

  return {
    columns
  }
}

export default usePropertyDialog;